
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGrnEmailEntry } from "./useGrnEmailVerification";
import { Button } from "../Common/styles.common";
import { GrnBottomModal } from "./styles.grn";
import {
  EmailSheetWrapper,
  EmailSheetTitleRow,
  EmailSheetTitle,
  EmailInputContainer,
  EmailInput,
  EmailHintText,
  EmailErrorText,
  EmailCtaWrapper,
  EmailDismissButton,
} from "./styles.email";
import Spinner from "sushiweb/Spinner/Spinner";
import { strings } from "utils/constants/strings";

const NoEmailBottomSheet = ({
  isOpen,
  onClose,
  source,
  purchaseOrderId,
  grnId,
  formState,
}) => {
  const navigate = useNavigate();
  const { email, changeEmail, error, loading, handleVerifyClick } = useGrnEmailEntry({
    onSent: (verifiedEmail) => {
      onClose();
      navigate("/user/verify-email", {
        state: {
          email: verifiedEmail,
          source,
          purchaseOrderId,
          grnId,
          formState,
        },
      });
    },
  });

  return (
    <GrnBottomModal visible={isOpen} onClose={onClose}>
      <EmailSheetWrapper>

        {/* Title */}
        <EmailSheetTitleRow>
          <EmailSheetTitle>{strings.grnNoEmailSheetTitle}</EmailSheetTitle>
        </EmailSheetTitleRow>

        {/* Email input container */}
        <EmailInputContainer $hasError={!!error}>
          {/* Input box */}
          <EmailInput
            type="email"
            placeholder={strings.grnNoEmailSheetEmailPlaceholder}
            value={email}
            $hasError={!!error}
            onChange={(e) => changeEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleVerifyClick()}
          />

          {/* Descriptive text inside container */}
          <EmailHintText>
            {strings.grnDisputeEmailHint}<br />{strings.grnDisputeEmailHintUpdate}
          </EmailHintText>
        </EmailInputContainer>

        {/* Inline error */}
        {error ? <EmailErrorText>{error}</EmailErrorText> : null}

        {/* CTA */}
        <EmailCtaWrapper>
          <Button
            className="fs-14 text-white fw-600"
            style={{ marginBottom: "0px" }}
            onClick={handleVerifyClick}
            disabled={loading}
          >
            {loading ? <Spinner color="white" /> : strings.grnNoEmailSheetVerifyOtp}
          </Button>

          {/* Secondary dismiss */}
          <EmailDismissButton onClick={onClose}>{strings.grnNoEmailSheetNotNow}</EmailDismissButton>
        </EmailCtaWrapper>
      </EmailSheetWrapper>
    </GrnBottomModal>
  );
};

export default NoEmailBottomSheet;
